// extracted by mini-css-extract-plugin
export default {"wrapper":"Pagination_wrapper__c6jKW","sideButton":"Pagination_sideButton__Ga9hM","pageButton":"Pagination_pageButton__dnx-V","icon":"Pagination_icon__zc3AP"};